export default __webpack_public_path__ + "static/media/mono-mujer.16bdba4e.png";